import { API_URL } from '../../../../constants/urls.constants';
import type { GetQueryArgsType } from '../../../../types/global.types';
import { appServiceApi } from '../../../apis/app-service.api';
import { APP_API_TAGS } from '../../../app.constants';
import { invalidateOnSuccess } from '../../../app.utils';
import type {
  AssessmentListResponse,
  AssessmentParams,
  SingleAssessmentResponse,
} from './assessment.type';

// Destructure tags
const { ASSESSMENTS } = APP_API_TAGS || {};

export const assessmentApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET: All Assessments
    getAllAssessments: builder.query<
      AssessmentListResponse,
      GetQueryArgsType<AssessmentParams>
    >({
      query: (queryArgs) => ({
        url: `${API_URL.recruitmentAssessments}`,
        method: 'GET',
        ...queryArgs,
      }),
      providesTags: [ASSESSMENTS],
    }),

    // GET: Single Assessment
    getSingleAssessment: builder.query<SingleAssessmentResponse, string>({
      query: (id) => ({
        url: `${API_URL.recruitmentAssessments}/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: ASSESSMENTS as any, id }],
    }),

    // POST: Create Assessment
    createAssessment: builder.mutation({
      query: (payload) => ({
        url: `${API_URL.recruitmentAssessments}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: invalidateOnSuccess(ASSESSMENTS),
    }),

    // PATCH: Update Assessment
    updateAssessment: builder.mutation({
      query: (payload) => ({
        url: `${API_URL.recruitmentAssessments}/${payload?.id}`,
        method: 'PATCH',
        body: payload?.body,
      }),
      invalidatesTags: invalidateOnSuccess([
        ASSESSMENTS,
        { type: ASSESSMENTS, id: true },
      ]),
    }),
  }),
});

export const {
  useGetAllAssessmentsQuery,
  useGetSingleAssessmentQuery,
  useCreateAssessmentMutation,
  useUpdateAssessmentMutation,
} = assessmentApi;
